import Tag from '@elements/Tag';
import { article } from '@/types/articles';
import { prepareArticleImage } from '@/utils/prepareArticleImage';

type articleHeaderProps = Pick<article, 'title' | 'author' | 'image' | 'isPaid' | 'categories' | 'publishedAt'>;

export default function ArticleHeader({ title, categories, image, isPaid }: articleHeaderProps) {
  const imageUrl = prepareArticleImage(image, 'original');

  return (
    <header
      className='mx-auto relative w-full print:h-auto print:mt-4 print:mb-0'
      style={{
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      data-cy='article-image'
    >
      <div className='absolute left-0 top-0 w-full h-full bg-gradient-to-r from-black via-black/80 to-emerald-800/60' />

      <div className='relative z-10 md:container mx-auto px-4 py-8 md:py-12 flex flex-col justify-center '>
        <div data-cy='article-categories' className='flex flex:row flex-wrap gap-y-2 print:hidden'>
          {categories?.map((category) => <Tag label={category.name} key={category.id} variant='gradient' />)}
          {!isPaid && <Tag key='free-tag' label='Free' variant='free' />}
        </div>

        <h1
          data-cy='article-title'
          className='mb-0 text-3xl md:text-4xl mt-4 md:max-w-[820px] text-white inline-block print:text-black print:text-3xl print:bg-none print:-mt-8'
        >
          {title}
        </h1>
      </div>
    </header>
  );
}
